if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
        };

        this.mql = window.matchMedia('(min-width: 750px)');
        this._syncingVariant = false;

        if (!this.elements.viewer) return;

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          'click',
          this.onViewerClick.bind(this)
        );

        this.elements.thumbnails
          .querySelectorAll('[data-target]')
          .forEach(thumbnail => {
            const button = thumbnail.querySelector('button');
            if (!button) return;

            button.addEventListener('click', () => {
              this.setActiveMedia(thumbnail.dataset.target, false);
            });
          });

        if (
          (this.dataset.desktopLayout || '').includes('thumbnail') &&
          this.mql.matches
        ) {
          this.removeListSemantic();
        }
      }

      onViewerClick(event) {
        if (!this.elements.thumbnails) return;

        const thumbnails = Array.from(
          this.elements.thumbnails.querySelectorAll('[data-target]')
        );

        const currentIndex = thumbnails.findIndex(thumbnail =>
          thumbnail.querySelector('button')?.getAttribute('aria-current')
        );

        if (currentIndex < 0) return;

        const bounds = this.elements.viewer.getBoundingClientRect();
        const direction =
          event.clientX - bounds.left > bounds.width / 2 ? 1 : -1;

        const next = thumbnails[currentIndex + direction];

        if (next) {
          this.setActiveMedia(next.dataset.target, false);
        }
      }

      onSlideChanged(event) {
        const mediaId =
          event.detail?.currentElement?.dataset.mediaId;

        if (!mediaId) return;

        const thumbnail = this.elements.thumbnails?.querySelector(
          `[data-target="${mediaId}"]`
        );

        this.setActiveThumbnail(thumbnail);
        this.syncVariantFromImage(mediaId);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer?.querySelector(
          `[data-media-id="${mediaId}"]`
        );

        if (!activeMedia) return;

        this.elements.viewer
          .querySelectorAll('[data-media-id]')
          .forEach(element => {
            element.classList.toggle(
              'is-active',
              element === activeMedia
            );
          });

        const thumbnail = this.elements.thumbnails?.querySelector(
          `[data-target="${mediaId}"]`
        );

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);

          if (thumbnail) {
            thumbnail.parentElement.prepend(thumbnail);
          }

          if (this.elements.viewer.slider) {
            this.elements.viewer.resetPages();
          }
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft
            });
          }

          if (
            !this.elements.thumbnails ||
            this.dataset.desktopLayout === 'stacked'
          ) {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });

        this.playActiveMedia(activeMedia);
        this.setActiveThumbnail(thumbnail);

        if (thumbnail) {
          this.announceLiveRegion(
            activeMedia,
            thumbnail.dataset.mediaPosition
          );
        }

        // Bei einer Änderung über die Galerie die Farbe mitführen.
        // prepend=true stammt aus der normalen Variantenauswahl.
        if (!prepend) {
          this.syncVariantFromImage(mediaId);
        }
      }

      syncVariantFromImage(mediaId) {
        return;
        if (this._syncingVariant || !mediaId) return;
        
        const picker = Array.from(document.querySelectorAll('variant-radios,variant-selects'))
          .find(element => this.id === `MediaGallery-${element.dataset.section}`);
        if (!picker || typeof picker.getVariantData !== 'function') return;
        
        picker.updateOptions();
        
        const groups = picker.matches('variant-radios')
          ? Array.from(picker.querySelectorAll('fieldset'))
          : Array.from(picker.querySelectorAll('select'));
          
        const colorIndex = groups.findIndex(group => {
          const name = group.matches('fieldset') ? group.querySelector('input')?.name : group.name;
          return /farbe|colou?r/i.test(name || '');
        });
        if (colorIndex < 0) return;
        
        const variants = picker.getVariantData();
        const id = String(mediaId).split('-').pop();
        
        const directColors = [...new Set(variants
          .filter(v => String(v.featured_media?.id) === id)
          .map(v => v.options[colorIndex]))];
          
        // KORREKTUR: Einzelnen Wert statt des Arrays auslesen
        let color = directColors.length === 1 ? directColors[0] : null;
        
        if (!color) {
          const item = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
          const image = item?.querySelector('img');
          const source = image?.currentSrc || image?.src;
          if (!source) return;
          
          let filename;
          try {
            filename = decodeURIComponent(new URL(source, location.href).pathname.split('/').pop()).toLowerCase();
          } catch (_) { return; }
          
          const slug = value => value.toLowerCase().normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-')
            .replace(/^-|-$/g, '');
            
          const colors = [...new Set(variants.map(v => v.options[colorIndex]))];
          const found = colors.filter(value => {
            const escaped = slug(value);
            return new RegExp(`-${escaped}-\\d+-[a-f0-9]{4}-`).test(filename);
          });
          
          if (found.length !== 1) return;
          // KORREKTUR: Einzelnen Wert statt des Arrays auslesen
          color = found[0];
        }
        
        const matches = variants.filter(v => v.options.every((value, index) =>
          index === colorIndex ? value === color : value === picker.options[index]
        ));
        
        // Keine andere Größe automatisch auswählen.
        if (matches.length !== 1) return;
        
        const group = groups[colorIndex];
        let control;
        
        if (group.matches('fieldset')) {
          control = Array.from(group.querySelectorAll('input')).find(input => input.value === color);
          if (!control || control.checked) return;
          control.checked = true;
        } else {
          control = group;
          if (control.value === color) return;
          control.value = color;
        }
        
        const originalUpdateMedia = picker.updateMedia;
        this._syncingVariant = true;
        picker.updateMedia = () => {};
        
        try {
          control.dispatchEvent(new Event('change', { bubbles: true }));
        } finally {
          picker.updateMedia = originalUpdateMedia;
          this._syncingVariant = false;
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach(button => {
            button.removeAttribute('aria-current');
          });

        thumbnail.querySelector('button')?.setAttribute(
          'aria-current',
          'true'
        );

        const slider = this.elements.thumbnails;

        if (
          typeof slider.isSlideVisible === 'function' &&
          slider.isSlideVisible(thumbnail, 10)
        ) return;

        slider.slider?.scrollTo({
          left: thumbnail.offsetLeft
        });
      }

            preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader ||
          document.querySelector('sticky-header');

        this.stickyHeader?.dispatchEvent(
          new Event('preventHeaderReveal')
        );
      }

      playActiveMedia(activeItem) {
        if (typeof window.pauseAllMedia === 'function') {
          window.pauseAllMedia();
        }

        const deferredMedia =
          activeItem.querySelector('.deferred-media');

        if (typeof deferredMedia?.loadContent === 'function') {
          deferredMedia.loadContent(false);
        }
      }

      removeListSemantic() {
        if (!this.elements.viewer?.slider) return;

        this.elements.viewer.slider.setAttribute(
          'role',
          'presentation'
        );

        this.elements.viewer.sliderItems?.forEach(slide => {
          slide.setAttribute('role', 'presentation');
        });
      }
announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          '.product__modal-opener--image img'
        );

        if (!image) return;

        this.elements.liveRegion.setAttribute('aria-hidden', 'false');
        this.elements.liveRegion.textContent = window.accessibilityStrings.imageAvailable.replace(
          '[position]',
          position
        );
      }
    }
  );
}
